import { render } from "./ChatRoom.vue?vue&type=template&id=d95f8608"
import script from "./ChatRoom.vue?vue&type=script&lang=js"
export * from "./ChatRoom.vue?vue&type=script&lang=js"
script.render = render

export default script